import {
    type ApiResult,
    type BaseParams,
    type CreateInviteData,
    type CreateInviteParam,
    links,
    Request,
} from '@app/client';

import { apiFactory } from '../../ApiFactory';

type InviteUserParams = BaseParams & CreateInviteParam;

function createInvite(params: InviteUserParams): Promise<ApiResult<CreateInviteData>> {
    return Request.postRequest<CreateInviteData>({
        ...params,
        target: links.invites().create(),
        value: {
            ...params,
        },
    });
}

export async function callCreateInvite(params: InviteUserParams): Promise<CreateInviteData> {
    return apiFactory()
        .call(createInvite, {
            ...params,
            group_id: params.group_id,
        })
        .then((result) => {
            if (result.ok) {
                return result.value;
            }
            const errorMessage = result?.error?.detail ?? 'Error creating invite';
            throw new Error(errorMessage);
        });
}
